import { useMemo } from 'react'
import { OnboardingState } from '../../hooks/use-onboarding-setup'
import { IOnboardingStep, OnboardingStepKey, OnboardingStepStatus } from '@cbgms/api'

export const useStepData = (step: OnboardingStepKey, onboardingInfo: OnboardingState, newInitialData?: unknown): IOnboardingStep => {
  return useMemo(() => {
    let stepData = onboardingInfo.stepData.find(s => s.Key === step) || emptyStepData(step)
    stepData = applyNewInitialData(stepData, newInitialData)
    return stepData
  }, [step, onboardingInfo.stepData, newInitialData])
}

const emptyStepData = (step: OnboardingStepKey): IOnboardingStep => {
  return { InitialData: {}, Key: step, State: OnboardingStepStatus.Off, DuplicationCheck: [] } //
}

const applyNewInitialData = (step: IOnboardingStep, newInitialData?: unknown): IOnboardingStep => {
  if (newInitialData) {
    return { ...step, InitialData: newInitialData }
  }
  return step
}
